import React from "react";
import Button from "../buttons/Button";
import useMedia from "../../hooks/useMedia";

const MAX_TITLE_SIZE = { desktop: 75, mobile: 60 };
const MAX_INFO_SIZE = { desktop: 50, mobile: 30 };

const EventCard = (event) => {
  const media = useMedia();
  const isMobile = media === "mobile";

  return (
    <div className="eventCard">
      <div className="eventCard_header">
        <div className="eventCard_location">
          {cutTextAtSize(event.location, getMaxSize(isMobile, MAX_INFO_SIZE))}
        </div>
        <div className="eventCard_date">{event.date.replace(/\//g, ".")}</div>
      </div>
      <h3 className="eventCard_title">
        {cutTextAtSize(
          event.title.rendered,
          getMaxSize(isMobile, MAX_TITLE_SIZE)
        )}
      </h3>
      <div className="eventCard_info">
        <div className="eventCard_organizer">
          {cutTextAtSize(event.organizer, getMaxSize(isMobile, MAX_INFO_SIZE))}
        </div>
        <div className="eventCard_speaker">{event.speaker}</div>
      </div>
      <div className="eventCard_actions">
        <a href={event.link} target="_blank" rel="noopener noreferrer">
          <Button arrowRight rounded big>
            More info
          </Button>
        </a>
      </div>
    </div>
  );
};

const getMaxSize = (isMobile, sizes) => sizes[isMobile ? "mobile" : "desktop"];

const cutTextAtSize = (text, maxSize) => {
  if (text.length > maxSize) return text.slice(0, maxSize - 3) + "...";
  else return text;
};

export default EventCard;
